import ButtonV2 from "@/v2/Buttons";
import LinkWrapper from "@/tpo/LinkWrapper";

export default function PrintFullReportButton({ printUrl, centered = false }) {
  if (!printUrl) return null;

  return (
    <ButtonV2
      color="dark"
      withChevron
      sx={centered ? { mx: "auto" } : { mr: "auto" }}
      as={LinkWrapper}
      to={printUrl}
      target="_blank"
      rel="noopener noreferrer"
      underline={false}
    >
      print full report
    </ButtonV2>
  );
}
